//import { mq } from '../../../../cssInJs';

export default {
    member_login : {
        
    }
}